export function camelCaseToDash(str: string) {
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
}

export function dashToCamelCase(str: string) {
  let characters = str.split(/|/);
  let result = '';
  for (let i=0; i<characters.length; i++) {
    if (characters[i] === '-' && characters[i+1]) {
      result += characters[++i].toUpperCase();
    } else {
      result += characters[i];
    }
  }
  return result;
}